import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HourSelectComponent } from './hour-select.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { OnlyNumberModule } from '@web-frontend/shared/directives/onlyNumber';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule.forChild(),
    OnlyNumberModule,
  ],
  declarations: [HourSelectComponent],
  exports: [HourSelectComponent],
})
export class HourSelectModule {}
